import React, { useEffect, useState } from 'react'
import { GetAll_Category_Api } from '../../API/CategoryApi';
import { ACategoryComponent } from './ACategoryComponent';
// ======================================================================
export const AllCategoryComponent = ({ setLoading, showMessage, parentId, isShowAddSubCategory, isShowEdit, editClick, isShowDelete, onRowDeleted, addSubCategoryClick, isLoadObjectInstanceCategories,isLoadCategoryFromParam,selectedCategory, isShowCheckBox, onCheckChange, objectInstanceId, onClickItems }) => {
    // ======================================================================
    const [categories, setCategories] = useState([]);
    // ======================================================================
    useEffect(() => {
        setCategories(null);
        loadData();
    }, [objectInstanceId]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Category_Api({ parentId: parentId, });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setCategories(data.messageData.data);
            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <ul className='category-list'> 
                {
                    categories?.map((category) =>
                        <>
                            <li className='category-item' key={category.id}>
                                <ACategoryComponent
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    category={category}
                                    isShowAddSubCategory={isShowAddSubCategory}
                                    isShowEdit={isShowEdit}
                                    isShowDelete={isShowDelete}
                                    onRowDeleted={onRowDeleted}
                                    editClick={editClick}
                                    addSubCategoryClick={addSubCategoryClick}
                                    isLoadObjectInstanceCategories={isLoadObjectInstanceCategories}
                                    isLoadCategoryFromParam={isLoadCategoryFromParam}
                                    selectedCategory={selectedCategory}
                                    objectInstanceId={objectInstanceId}
                                    isShowCheckBox={isShowCheckBox}
                                    onCheckChange={onCheckChange}
                                    onClickItems={onClickItems}
                                />
                            </li>
                            <AllCategoryComponent
                                setLoading={setLoading}
                                showMessage={showMessage}
                                parentId={category.id}
                                isShowAddSubCategory={isShowAddSubCategory}
                                isShowEdit={isShowEdit}
                                editClick={editClick}
                                isShowDelete={isShowDelete}
                                onRowDeleted={onRowDeleted}
                                addSubCategoryClick={addSubCategoryClick}
                                isLoadObjectInstanceCategories={isLoadObjectInstanceCategories}
                                isLoadCategoryFromParam={isLoadCategoryFromParam}
                                selectedCategory={selectedCategory}
                                isShowCheckBox={isShowCheckBox}
                                onCheckChange={onCheckChange}
                                objectInstanceId={objectInstanceId}
                                onClickItems={onClickItems}
                            />
                        </>
                    )
                }
            </ul>
        </>
    )
}
